"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiInput = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var IconSymbols_1 = require("../../../generated/IconSymbols");
var mobx_react_1 = require("mobx-react");
var react_1 = require("react");
var Button_1 = require("../../Button");
var Icon_1 = require("../../Icon");
var Pill_1 = require("../../Pill");
var Input_1 = require("../Input");
exports.MultiInput = (0, mobx_react_1.observer)(function (props) {
    var _a = (0, react_1.useState)(""), value = _a[0], setValue = _a[1];
    return (0, jsx_runtime_1.jsxs)("div", __assign({ className: "multi-input" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "mb-3 multi-input__controls" }, { children: [(0, jsx_runtime_1.jsx)(Input_1.Input, __assign({}, props.inputProps, { value: value, className: "multi-input__input ".concat(props.inputProps && props.inputProps.className ? props.inputProps.className : ""), onChange: function (event) {
                            // Cancel the default action, if needed
                            event.preventDefault();
                            setValue(event.currentTarget.value);
                        }, onKeyDown: function (event) {
                            if (event.keyCode === 13) {
                                // Cancel the default action, if needed
                                event.preventDefault();
                                props.onEnter(value);
                                if (props.clearOnEnter) {
                                    setValue("");
                                }
                            }
                        } })), (0, jsx_runtime_1.jsx)(Button_1.ButtonIcon, { className: "multi-input__button", symbol: IconSymbols_1.IconSymbols.Plus, onClick: function () {
                            props.onEnter(value);
                            if (props.clearOnEnter) {
                                setValue("");
                            }
                        } })] })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "multi-selector_menu" }, { children: Array.isArray(props.selectedItems) &&
                    props.selectedItems.map(function (e, i) {
                        if (e === null) {
                            return null;
                        }
                        return ((0, jsx_runtime_1.jsxs)(Pill_1.Pill, __assign({ className: "m-1" }, { children: [(0, jsx_runtime_1.jsx)("p", __assign({ className: "mb-0 d-inline-block" }, { children: props.valueLabelFn(e) })), (0, jsx_runtime_1.jsx)("span", __assign({ onClick: function (ee) { return props.removeItem(e, i); } }, { children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { symbol: IconSymbols_1.IconSymbols.Close, className: "ml-2" }) }))] }), i));
                    }) }))] }));
});
